import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import StripeCheckoutComponent from './Stripe/CheckoutComponent';
import VoucherCheckoutComponent from './Voucher/CheckoutComponent';
import { i18n } from '../../../common/services/globalize';

class CheckoutComponent extends Component {
	getPaymentMethodCheckoutComponent() {
		const { paymentMethod, isInstalmentPayment, onPaymentMethodInit, showManualInstalments, currency, t, ...rest } = this.props;

		const descriptionResourceKey = `FO_PaymentMethod_${paymentMethod.name}_Description`;
		const descriptionResourceKeyWithSuffix = `FO_PaymentMethod_${paymentMethod.name}_Description_${isInstalmentPayment ? 'Instalment' : currency}`;
		const description = <div className='description' dangerouslySetInnerHTML={{ __html: t(i18n.exists(descriptionResourceKeyWithSuffix) ? descriptionResourceKeyWithSuffix : descriptionResourceKey) }} />;

		switch (paymentMethod.name) {
			case 'Stripe':
				return <StripeCheckoutComponent paymentMethod={paymentMethod} onPaymentMethodInit={onPaymentMethodInit} currency={currency} isInstalmentPayment={isInstalmentPayment} {...rest} />;
			case 'Voucher':
				return <div>
					{description}
					<VoucherCheckoutComponent paymentMethod={paymentMethod} onPaymentMethodInit={onPaymentMethodInit} currency={currency} isInstalmentPayment={isInstalmentPayment} {...rest} />
				</div>;
			default:
				return <div>
					{description}
					{showManualInstalments && paymentMethod.supportsManualInstalments && <div className='description' dangerouslySetInnerHTML={{ __html: t('FO_PaymentMethod_SupportsManualInstalments') }} />}
				</div>;
		}
	}

	render() {
		return this.getPaymentMethodCheckoutComponent();
	}
}

export default withTranslation()(CheckoutComponent);